import Splide from '@splidejs/splide';

export default function carouselCardsIcon() {

    const carousels = document.querySelectorAll('.carousel-cards-icon');

    carousels.forEach(carousel => {
        const splideEl = carousel.querySelector('.splide');
        if (!splideEl) return;

        new Splide(splideEl, {
            perPage: 4,
            perMove: 1,
            gap: 8,
            pagination: false,
            padding: {
                right: '4rem',
            },
            arrows: false,
            breakpoints: {
                1024: {
                    perPage: 3,
                    padding: {
                        right: '3rem',
                    },
                },
                768: {
                    perPage: 2,
                    padding: {
                        right: '2rem',
                    },
                },
                480: {
                    perPage: 1,
                    padding: {
                        right: '1.5rem',
                    },
                },
            },
        }).mount();
    });

}
